import React from "react";
import { Form, Alert, InputGroup } from "react-bootstrap";
import Select from "react-select";
import "./FormExtension.css"; // Create this CSS file for custom styles

function FormExtension({
  index,
  instances,
  onChangeInArray,
  products,
  onChangeInArray1,
  disabled = false,
}) {
  const filterOption = ({ label, value }, string) => {
    // default search

    if (label.toLocaleLowerCase().includes(string.toLowerCase()) || value.toLocaleLowerCase().includes(string.toLowerCase())) return true;

    // check if a group as the filter string as label
    const groupOptions = products.filter((group) =>
      group.label.toLocaleLowerCase().includes(string.toLowerCase())
    );

    if (groupOptions && products) {
      for (const groupOption of groupOptions) {
        // Check if current option is in group
        const option = groupOption.options.find((opt) => opt.value === value);
        if (option) {
          return true;
        }
      }
    }
    return false;
  };
  return (
    <div key={index} className="form-extension">
      <Alert key={index} variant="primary" className="mb-3">
        instance {index + 1} detail
      </Alert>
      <Form.Group className="mb-3" controlId={`provisioned_product_id-${index}`}>
        <Form.Label>Provisioned Product Identifier</Form.Label>
        <div className="productids">
          {products && <Select
            //change options to products for real use
            options={products}
            value={instances[index].provisioned_product_id}
            className="mb-3"
            placeholder="Choose a Product Name"
            isSearchable
            isDisabled={disabled}
            autoFocus
            onChange={(products) =>
              onChangeInArray1({
                target: { label: `provisioned_product_id-${index}`, value: products },
              })
            }
            filterOption={filterOption}
          />}
        </div>
        <div className="product-info">
          <div className="info-item">
            <span className="info-label">Hostname: </span>
            <span className="info-value">{instances[index].provisioned_product_id.hostname} </span>
          </div>
          <div className="info-item">
            <span className="info-label">ProductID: </span>
            <span className="info-value">{instances[index].provisioned_product_id.value} </span>
          </div>
        </div>
      </Form.Group>
      <Form.Group className="mb-3" controlId={`delay-${index}`}>
        <Form.Label>Delay</Form.Label>
        <InputGroup>
        <Form.Control
          type="number"
          value={instances[index].delay}
          disabled={disabled}
          onChange={onChangeInArray}
          min={10}
          max={1200}
          placeholder="The VM wait time to be ready in seconds"
        />
        <InputGroup.Append>
        <InputGroup.Text style={{ backgroundColor: 'white'}}>secs</InputGroup.Text>
        </InputGroup.Append> 
      </InputGroup>
      </Form.Group>
      <Form.Group className="mb-3" controlId={`launching_order-${index}`}>
        <Form.Label>Launching order</Form.Label>
        <Form.Control
          type="number"
          value={instances[index].launching_order}
          disabled={disabled}
          onChange={onChangeInArray}
        />
      </Form.Group>
    </div>
  );
}

export default FormExtension;
